@import '~style-sheet-helpers/core.less';
@import '../../constants/spacing.module.less';

@upsellBackgroundColor: var(--green-E5F6EE);
@altUpsellBackgroundColor: var(--purple-F6F2FF);
@alternateBackgroundColor: #f7f7f9;

.image-wrapper {
  display: flex;
  background-color: @upsellBackgroundColor;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex: 3;

  > img {
    max-width: 100%;
  }
}

.align-bottom {
  justify-content: flex-end;
  align-items: flex-end;
}

.alt-background {
  background-color: @alternateBackgroundColor;
}

.purple-background {
  background-color: @altUpsellBackgroundColor;
}
